import React, { Fragment, useContext, useEffect, useState } from "react";
import a from "../../../resources/images/nftf/exclamation-circle.svg";
import {
  CardArea,
  CommentDiv,
  ContentBody,
  FlexDiv,
  SeparateLine,
  TitleDiv,
  TitleIcon,
  TitleText,
} from "./MedicalCardStyle";

import { AppContext } from "../../../components/AppProvider";
import {
  PostApi1970,
  PostApi1971,
  PostApi222,
  postZoomSessionId,
} from "../../../modules/network/padoPost";
import { _O } from "../../../modules/utils";
import {
  changeDateFormat,
  stringToTelNo,
} from "../../../modules/utils/CheckLogic";
import { getAccessTokenApi } from "../../../modules/utils/ZoomApi";
import IconReceipt from "../../../resources/images/nftf/Icon_receipt_purple.svg";
import {
  ContentTd,
  TableContentDiv,
  TableDiv,
  TableTitleDiv,
  TitleTd,
} from "../../Reservation/ReserveStyle";
import Button from "./../../../components/UI/Button/Button";

const MedicalCard = props => {
  const { userinfo, phonecfg, cfg } = useContext(AppContext);
  const [minGap, setMinGap] = useState();
  const {
    nftfData,
    getNftfReceiptList,
    nftfConnect,
    setNftfConnect,
    setNftfData,
  } = props;

  // appStatus
  // 1: 예약대기 2: 예약대기 3: 예약대기 4: 지연 5: 일시변경
  // 1:예약 4.접수(환자 미확인) 7.접수(환자확인) 9:접수취소 10.접수반려 11:진료대기 12:진료중 13:진료종료

  const onCardClick = () => {
    if (nftfConnect) {
      // alert('진료실에 입장중입니다. 잠시만 기다려주세요');
    } else {
      if (phonecfg.phoneOS === "ANDROID") {
        if (parseInt(phonecfg.version.split(".")[2]) > 85) {
          setNftfConnect(true);
        }
      } else {
        if (parseInt(phonecfg.version.split(".")[2]) > 39) {
          setNftfConnect(true);
        }
      }

      // if (nftfData.pharmName && nftfData.pharmName != "") {
      if (nftfData.telmdcnOpenYn === "Y") {
        joinRoom(
          nftfData.seqNo,
          nftfData.hsptCd,
          nftfData.hsptNm,
          nftfData.telmdcnFrDh
        );
      } else {
        if (nftfData.appStatus === 1) {
          _O.Open("/resrvList/1/" + nftfData.seqNo);
        } else if (nftfData.appStatus === 4) {
          // request223(seqNo, 7);
        } else if (nftfData.appStatus === 9 || nftfData.appStatus === 10) {
          request1971(nftfData.seqNo, nftfData.appStatus);
          setNftfConnect(false);
        } else {
          _O.Open("/resrvList/1/" + nftfData.seqNo);
        }
      }
    }
  };
  const joinRoom = (seqNo, hsptCode, hsptName, telmdcnFrDh) => {
    PostApi1970(userinfo, cfg, phonecfg, seqNo)
      .then(res => {
        if (res.resultMsg === "Success") {
          setNftfData(res.result);
          if (res.result[0].zoomSessId != "") {
            postZoomSessionId(res.result[0].zoomSessId, cfg)
              .then(resSession => {
                if (
                  resSession &&
                  resSession.users &&
                  resSession.users.length > 0
                ) {
                  getAccessTokenApi(
                    hsptCode.toString(),
                    seqNo.toString(),
                    hsptName,
                    telmdcnFrDh,
                    userinfo,
                    phonecfg,
                    cfg
                  );
                } else {
                  alert("진료실에 입장한 의료진이 없습니다.");
                  setNftfConnect(false);
                }
              })
              .catch(err => {
              });
          } else {
            alert("진료실에 입장한 의료진이 없습니다.");
            setNftfConnect(false);
          }
        }
      })
      .catch(err => {
        setNftfConnect(false);
      });
  };

  const request222 = (userinfo, cfg, phonecfg, appIdx) => {
    PostApi222(userinfo, cfg, phonecfg, appIdx)
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          getNftfReceiptList();
        }
      })
      .catch(err => {
      });
  };

  const request1971 = (seqNo, appStatus) => {
    PostApi1971(userinfo, cfg, phonecfg, seqNo, appStatus)
      .then(res => {
        if (res.resultMsg === "SUCC") {
          // 리스트 갱신
          getNftfReceiptList();
        }
      })
      .catch(err => {
      });
  };

  const checkNftfMinGap = () => {
    const today = new Date();
    const timeValue = new Date(nftfData.appDelayTime);

    setMinGap(
      Math.floor(timeValue.getTime() / 1000 / 60) -
        Math.floor(today.getTime() / 1000 / 60)
    );
  };

  useEffect(() => {
    checkNftfMinGap();
    const timerEvent = setInterval(() => {
      checkNftfMinGap();
    }, 60000);
    return () => clearInterval(timerEvent);
  }, []);

  return (
    <CardArea>
      <TitleDiv>
        <TitleText>비대면 진료 예약내역</TitleText>
        {nftfData.appStatusNm && (
          <StatusCpnt minGap={minGap} nftfData={nftfData} />
        )}
      </TitleDiv>

      <SeparateLine />

      <ContentBody>
        <FlexDiv>
          <table style={{ wordBreak: "keep-all", tableLayout: "fixed" }}>
            <tbody>
              <tr>
                <TitleTd>이름</TitleTd>
                <ContentTd>
                  {nftfData.rqstRelcd === "FAMZ"
                    ? nftfData.famzNm
                    : userinfo.userName}
                </ContentTd>
              </tr>
              <tr>
                <TitleTd>병원명</TitleTd>
                <ContentTd>{nftfData.hsptNm}</ContentTd>
              </tr>

              {(nftfData.appStatus === 1 || nftfData.appStatus === 10) && (
                <tr>
                  <TitleTd>예약일시</TitleTd>
                  <ContentTd>
                    <div style={{ display: "flex", gap: "8px" }}>
                      {nftfData.appStatus === 7 ? (
                        <Fragment>
                          {/* {changeDateFormat(nftfData.appConfirmTime)} */}
                          {changeDateFormat(nftfData.appDelayTime)}
                          <div style={{ color: "#6B65DE" }}>
                            {nftfData.appStatusNm != "진료중" &&
                              nftfData.tmDiff &&
                              nftfData.tmDiff > 0 &&
                              Math.abs(nftfData.tmDiff) + "분 지연"}
                          </div>
                        </Fragment>
                      ) : nftfData.appTime ? (
                        changeDateFormat(nftfData.appTime)
                      ) : (
                        changeDateFormat(nftfData.appDelayTime)
                      )}
                    </div>
                  </ContentTd>
                </tr>
              )}

              {nftfData.appStatus === 2 && (
                <Fragment>
                  <tr>
                    <TitleTd>
                      {nftfData.appStatusNm === "지연"
                        ? "변경일시"
                        : "확정일시"}
                    </TitleTd>
                    <ContentTd>
                      <div style={{ display: "flex", gap: "8px" }}>
                        {changeDateFormat(nftfData.appDelayTime)}
                      </div>
                    </ContentTd>
                  </tr>
                  {(nftfData.appStatus === 4 || nftfData.appStatus === 7) &&
                    nftfData.appComm && (
                      <tr>
                        <TitleTd>접수정보</TitleTd>
                        <ContentTd style={{ color: "#6B65DE" }}>
                          {nftfData.appComm}
                        </ContentTd>
                      </tr>
                    )}
                </Fragment>
              )}

              {nftfData.appConfirmTime ? (
                <Fragment>
                  <tr>
                    <TitleTd>
                      {nftfData.appStatusNm === "지연"
                        ? "변경일시"
                        : "확정일시"}
                    </TitleTd>
                    <ContentTd>
                      {/* {nftfData.appStatus != 7 && nftfData.appConfirmTime && ( */}
                      {nftfData.appConfirmTime && (
                        <div style={{ display: "flex", gap: "8px" }}>
                          {nftfData.appStatus === 5
                            ? changeDateFormat(nftfData.appDelayTime)
                            : changeDateFormat(nftfData.appConfirmTime)}
                        </div>
                      )}
                    </ContentTd>
                  </tr>
                  {(nftfData.appStatus === 4 || nftfData.appStatus === 7) &&
                    nftfData.appComm && (
                      <tr>
                        <TitleTd>접수정보</TitleTd>
                        <ContentTd style={{ color: "#6B65DE" }}>
                          {nftfData.appComm}
                        </ContentTd>
                      </tr>
                    )}
                </Fragment>
              ) : null}

              {nftfData.delayRsn ? (
                <tr>
                  <TitleTd>변경사유</TitleTd>
                  <ContentTd style={{ color: "#6B65DE" }}>
                    {nftfData.delayRsn}
                  </ContentTd>
                </tr>
              ) : null}

              {nftfData.rejctRsn ? (
                <tr>
                  <TitleTd>반려사유</TitleTd>
                  <ContentTd>
                    <div style={{ color: "#6B65DE" }}>{nftfData.rejctRsn}</div>
                  </ContentTd>
                </tr>
              ) : null}
            </tbody>
          </table>
        </FlexDiv>

        {
          nftfData.pharmName && nftfData.pharmName != "" && (
            <Fragment>
              <SeparateLine />
              <TableDiv>
                <div>
                  {nftfData.pharmName && <TableTitleDiv>약국명</TableTitleDiv>}
                  {nftfData.pharmFaxNum && (
                    <TableTitleDiv>팩스번호</TableTitleDiv>
                  )}
                  {nftfData.pharmTelNo && (
                    <TableTitleDiv>전화번호</TableTitleDiv>
                  )}
                </div>
                <div>
                  {nftfData.pharmName && (
                    <TableContentDiv>{nftfData.pharmName}</TableContentDiv>
                  )}
                  {nftfData.pharmFaxNum && (
                    <TableContentDiv>
                      {stringToTelNo(nftfData.pharmFaxNum)}
                    </TableContentDiv>
                  )}
                  {nftfData.pharmTelNo && (
                    <TableContentDiv>
                      {stringToTelNo(nftfData.pharmTelNo)}
                    </TableContentDiv>
                  )}
                </div>
              </TableDiv>
            </Fragment>
          )
          //  : (
          //   nftfData.appStatus != 10 && (
          //     <Fragment>
          //       <div
          //         style={{
          //           width: "100%",
          //           textAlign: "center",
          //           display: "flex",
          //           flexFlow: "column",
          //           gap: "24px",
          //         }}>
          //         {/* <div>
          //           <img src={IC.etc.ICON_PILL} />
          //           <div style={{ color: "#888" }}>
          //             처방받을 약국정보를 입력하지 않았어요
          //           </div>
          //         </div> */}

          //         <Button
          //           severity={"primary_light"}
          //           disable={"off"}
          //           small={false}
          //           clickEvent={() => onCardClick()}>
          //           약국정보 입력하기
          //         </Button>
          //       </div>
          //     </Fragment>
          //   )
          // )
        }
        {nftfData.telmdcnOpenYn === "Y" && nftfData.zoomSessId === "" && (
          <CommentDiv>
            <div style={{ width: "16px", height: "16px" }}>
              <img src={a} />
            </div>
            <div>진료 준비중입니다 잠시 후 다시 시도하세요</div>
          </CommentDiv>
        )}
        <div style={{ display: "flex", gap: "8px", width: "100%" }}>
          {nftfData.pharmName == "" && (
            <Button
              severity={"primary_light"}
              disable={"off"}
              small={false}
              // clickEvent={() => onCardClick()}>
              clickEvent={() => _O.Open("/nftf/receiptMod/" + nftfData.seqNo)}>
              약국정보 입력하기
            </Button>
          )}

          {nftfData.telmdcnOpenYn === "Y" ? (
            <Fragment>
              {/* 일시변경 & 진료지연만 표시 */}
              <Button
                severity={"primary"}
                disable={"off"}
                small={false}
                clickEvent={
                  () => onCardClick()
                  // joinRoom(
                  //   nftfData.seqNo,
                  //   nftfData.hsptCd,
                  //   nftfData.hsptNm,
                  //   nftfData.telmdcnFrDh
                  // )
                }>
                진료실 들어가기
              </Button>
            </Fragment>
          ) : // ) : nftfData.appStatus === 4 || nftfData.appStatus === 5 ? (
          nftfData.appStatus === 4 ? (
            <Fragment>
              <Button
                severity={"primary"}
                disable={"off"}
                small={false}
                clickEvent={() =>
                  request1971(nftfData.seqNo, nftfData.appStatus)
                }>
                네, 가능합니다
              </Button>
            </Fragment>
          ) : (
            (nftfData.appStatus === 1 && minGap < 0) ||
            ((nftfData.appStatus === 10 || nftfData.appStatus === 9) && (
              <Fragment>
                {/* 일시변경 & 진료지연만 표시 */}
                <Button
                  severity={"light"}
                  disable={"off"}
                  small={false}
                  clickEvent={() =>
                    request222(userinfo, cfg, phonecfg, nftfData.seqNo)
                  }>
                  확인
                </Button>
              </Fragment>
            ))
          )}
        </div>

        {/* 버튼 조건 변경 */}
        {nftfData.telmdcnOpenYn === "Y" ? (
          <Fragment>
            {/* <Button color={"true"}>비대면진료실 들어가기</Button> */}
          </Fragment>
        ) : nftfData.appStatus === 4 || nftfData.appStatus === 5 ? (
          <Fragment>
            {/* 일시변경 & 진료지연만 표시 */}
            <CommentDiv>
              <div style={{ width: "16px", height: "16px" }}>
                <img src={a} />
              </div>
              <div onClick={() => _O.Open("/resrvList/1/" + nftfData.seqNo)}>
                변경된 시간이 불가능한 경우{" "}
                <font style={{ color: "blue", textDecoration: "underline" }}>
                  예약현황
                </font>
                에서 취소하세요
              </div>
            </CommentDiv>
            {/* <Button
              severity={"primary"}
              disable={"off"}
              small={false}
              clickEvent={() =>
                request1971(nftfData.seqNo, nftfData.appStatus)
              }>
              네, 가능합니다
            </Button> */}
          </Fragment>
        ) : (
          (nftfData.appStatus === 1 && minGap < 0) ||
          ((nftfData.appStatus === 10 || nftfData.appStatus === 9) && (
            <Fragment>
              {/* 일시변경 & 진료지연만 표시 */}
              {nftfData.appStatus != 9 && (
                <CommentDiv>
                  <div style={{ width: "16px", height: "16px" }}>
                    <img src={a} />
                  </div>
                  <div>진료지연에 관한 자세한 내용은 병원에 문의하세요</div>
                </CommentDiv>
              )}
              {/* <Button
                severity={"light"}
                disable={"off"}
                small={false}
                clickEvent={() =>
                  request222(userinfo, cfg, phonecfg, nftfData.seqNo)
                }>
                확인
              </Button> */}
            </Fragment>
          ))
        )}
      </ContentBody>
    </CardArea>
  );
};

const StatusCpnt = (props) => {
  const { minGap, nftfData } = props;
  return (
    <TitleIcon>
      {nftfData.appStatusNm === "진료중" ||
      nftfData.appStatusNm === "예약대기" ||
      nftfData.appStatusNm === "예약반려"
        ? nftfData.appStatusNm
        : minGap >= 0
        ? minGap > 5
          ? nftfData.appStatusNm
          : minGap + "분 후 시작"
        : minGap < 0
        ? Math.abs(minGap) + "분 지연"
        : nftfData.appStatusNm != "5분 후 시작" &&
          nftfData.appStatusNm != "지연" &&
          nftfData.appStatusNm}
      <img src={IconReceipt} />
    </TitleIcon>
  );
};

export default MedicalCard;
